import React, { useMemo, useState, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import { agGridTheme, grid, defaultColDef, StatusBadgeRenderer } from "../../styles/theme";
import JobDetail from "./JobDetail";   // ✅ import
import "../../styles/theme.css";

import { formatDuration, formatDateTime } from "../../utils/utils";

ModuleRegistry.registerModules([AllCommunityModule]);

const JobList = ({ jobs = [] }) => {
  const [selectedJob, setSelectedJob] = useState(null);
  const gridRef = useRef(null); // reference to the grid

  const rowData = jobs;

  const columns = useMemo(
    () => [
      { headerName: "Job Tag", field: "job_tag" },
      { headerName: "Job Type", field: "pipeline_name" },
      {
        headerName: "Status",
        field: "status",
        cellRenderer: StatusBadgeRenderer,
        cellStyle: { display: "flex", justifyContent: "center", alignItems: "center" },
      },
      {
        headerName: "Duration",
        field: "duration",
        cellRenderer: (params) => formatDuration(params.value),
      },
      {
        headerName: "Start Time",
        field: "start_time",
        cellRenderer: (params) => formatDateTime(params.value),
      },
      {
        headerName: "End Time",
        field: "end_time",
        cellRenderer: (params) => formatDateTime(params.value),
      },
      { headerName: "Unique Job ID", field: "unique_job_id" },
    ],
    []
  );

  const onRowClicked = (event) => {
    setSelectedJob(event.data); // capture clicked row

    // make AG Grid select this row
    gridRef.current?.api.forEachNode((node) => {
      node.setSelected(node.data === event.data);
    });
  };


  useEffect(() => {
    if (rowData.length > 0) {
      setSelectedJob(rowData[0]);

      const firstRowNode = gridRef.current?.api.getDisplayedRowAtIndex(0);
      if (firstRowNode) firstRowNode.setSelected(true);
    } else {
      // 🔴 IMPORTANT: clear selection when no jobs
      setSelectedJob(null);
    }
  }, [rowData]);

  return (
    <div>
      <div style={grid.container}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columns}
          defaultColDef={defaultColDef}
          theme={agGridTheme}
          pagination={true}
          paginationPageSize={10}
          paginationPageSizeSelector={[10, 20, 50, 100]}
          domLayout="autoHeight"
          onRowClicked={onRowClicked}
          rowClassRules={{
            "job-details-highlight": (params) => params.data === selectedJob, // highlight selected row
          }}
        />
      </div>

      {/* ✅ Job details panel below grid */}
      <JobDetail job={selectedJob} />
    </div>
  );
};

export default JobList;
